import { useState, useRef, useEffect, useContext } from 'react';
import { Dialog, Toast, Button } from 'react-weui';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import { ActionContext } from '../actions/context';

function Modal(props) {
  const { state, dispatch } = useContext(ActionContext);
  const {
    showDialog,
    dialogMsg,
    showTip,
    tipMsg,
    errorMsg,
    showLoading,
    showReject,
    content,
    reasonStr,
    title,
    ok,
    cancel
  } = state;
  const [reason, setReason] = useState('');

  useEffect(() => {
    setReason(reasonStr);
  }, [reasonStr]);

  const style2 = {
    title: '',
    buttons: [
      {
        type: 'default',
        label: '取消',
        onClick: () => {
          dispatch({ type: 'hideDialog' });
          cancel();
        }
      },
      {
        type: 'primary',
        label: '确认',
        onClick: () => {
          dispatch({ type: 'hideDialog' });
          ok();
        }
      }
    ]
  };

  function reasonChange(event) {
    setReason(event.target.value);
  }

  return (
    <div>
      <Dialog
        type="ios"
        title={style2.title}
        buttons={style2.buttons}
        show={showDialog}
      >
        {dialogMsg}
      </Dialog>
      <Drawer anchor="bottom" open={showReject}>
        <div className="MuiDrawer-paper">
          <div className="text-field-item">
            <TextField
              id="outlined-full-width"
              label={title}
              value={reason}
              onChange={reasonChange}
              margin="normal"
              rows="3"
              multiline
              fullWidth
              variant="outlined"
            />
          </div>
          <p className="mt15 m-flex-box">
            <Button
              type="default"
              className="m-flex-item u-btn u-btn_primary"
              onClick={() => {
                ok(reason);
              }}
            >
              确定
            </Button>
            <Button
              type="default"
              className="m-flex-item u-btn u-btn_line"
              onClick={() => {
                dispatch({ type: 'hideReject' });
              }}
            >
              取消
            </Button>
          </p>
        </div>
      </Drawer>
      <Toast icon="success-no-circle" show={showTip}>
        {tipMsg || '完成'}
      </Toast>
      <Toast icon="warn" show={typeof errorMsg === 'string'}>
        {errorMsg}
      </Toast>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </div>
  );
}

export default Modal;
